import { authenticatedPost } from '../../../../../api/request';

export default async function createNewUser(saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando el nuevo usuario.');
    const url = '/web-admin-data/signup';
    return await authenticatedPost(url, onFail, saveData);
}
